(function () {
  'use strict';

  const CONFIG = {
    swiperSelector: '.product-video-swiper-unique',
    slideSelector: '.product-video-slide-unique',
    overlaySelector: '#video-overlay',
    containerSelector: '.video-container',
    closeButtonSelector: '.close-video',
    prevButtonSelector: '.swiper-button-prev-video-unique',
    nextButtonSelector: '.swiper-button-next-video-unique',
    slidesPerView: 3.5,
    spaceBetween: 12,
    initDelay: 100,
    protectionInterval: 500,
  };

  function getSwiper() {
    const swiperEl = document.querySelector(CONFIG.swiperSelector);
    return swiperEl ? swiperEl.swiper : null;
  }

  function updateButtonStates() {
    const swiper = getSwiper();
    const prevBtn = document.querySelector(CONFIG.prevButtonSelector);
    const nextBtn = document.querySelector(CONFIG.nextButtonSelector);

    if (!swiper || !prevBtn || !nextBtn) return;

    if (swiper.isBeginning) {
      prevBtn.classList.add('swiper-button-disabled');
      prevBtn.style.opacity = '0.3';
      prevBtn.style.cursor = 'not-allowed';
    } else {
      prevBtn.classList.remove('swiper-button-disabled');
      prevBtn.style.opacity = '1';
      prevBtn.style.cursor = 'pointer';
    }

    if (swiper.isEnd) {
      nextBtn.classList.add('swiper-button-disabled');
      nextBtn.style.opacity = '0.3';
      nextBtn.style.cursor = 'not-allowed';
    } else {
      nextBtn.classList.remove('swiper-button-disabled');
      nextBtn.style.opacity = '1';
      nextBtn.style.cursor = 'pointer';
    }
  }

  function initGifCarousel() {
    if (typeof Swiper === 'undefined') {
      setTimeout(initGifCarousel, 200);
      return;
    }

    const swiperEl = document.querySelector(CONFIG.swiperSelector);
    if (!swiperEl) return;

    const wrapper = document.querySelector('.video-carousel-unique');
    if (wrapper) {
      const margin = wrapper.getAttribute('data-margin-bottom');
      if (margin) {
        wrapper.style.setProperty('--video-margin-bottom', `${margin}px`);
      }
    }

    if (swiperEl.swiper) {
      swiperEl.swiper.destroy(true, true);
    }

    new Swiper(CONFIG.swiperSelector, {
      slidesPerView: CONFIG.slidesPerView,
      spaceBetween: CONFIG.spaceBetween,
      on: {
        init: function () {
          setTimeout(() => {
            setupLazyLoading();
            updateButtonStates();
          }, CONFIG.initDelay);
        },
        slideChange: function () {
          updateButtonStates();
        },
      },
    });
  }

  function setupLazyLoading() {
    const slides = document.querySelectorAll(CONFIG.slideSelector);

    slides.forEach((slide) => {
      const img = slide.querySelector('.video-preview-unique img');
      if (!img || slide.classList.contains('gif-loaded')) return;

      slide.classList.add('gif-loading');

      if (img.complete && img.naturalHeight !== 0) {
        slide.classList.remove('gif-loading');
        slide.classList.add('gif-loaded');
      } else {
        img.addEventListener('load', () => {
          slide.classList.remove('gif-loading');
          slide.classList.add('gif-loaded');
        }, { once: true });

        img.addEventListener('error', () => {
          slide.classList.remove('gif-loading');
          slide.classList.add('gif-error');
        }, { once: true });
      }
    });
  }

  function openGif(gifUrl) {
    const overlay = document.querySelector(CONFIG.overlaySelector);
    const container = document.querySelector(CONFIG.containerSelector);

    if (!gifUrl || !overlay || !container) return;

    container.innerHTML = `
      <div class="gif-modal-loader">
        <div class="loader-spinner"></div>
        <p>Loading...</p>
      </div>
    `;
    overlay.classList.remove('hidden');
    document.body.classList.add('no-scroll');

    const img = document.createElement('img');
    img.alt = 'Product media';
    img.style.cssText = 'width:100%;height:100%;border-radius:8px;object-fit:contain;opacity:0;transition:opacity 0.3s ease;';

    img.onload = () => {
      container.innerHTML = '';
      container.appendChild(img);
      requestAnimationFrame(() => {
        img.style.opacity = '1';
      });
    };

    img.onerror = () => {
      container.innerHTML = `
        <div class="gif-error-message">
          <p>Failed to load image</p>
          <button class="retry-button">Close</button>
        </div>
      `;
    };

    img.src = gifUrl;
  }

  function closeGif() {
    const overlay = document.querySelector(CONFIG.overlaySelector);
    const container = document.querySelector(CONFIG.containerSelector);

    if (overlay) overlay.classList.add('hidden');
    if (container) container.innerHTML = '';
    document.body.classList.remove('no-scroll');
  }

  function handleClick(e) {
    // Prev button
    if (e.target.closest(CONFIG.prevButtonSelector)) {
      e.preventDefault();
      e.stopPropagation();
      const swiper = getSwiper();
      if (swiper && !swiper.isBeginning) {
        swiper.slidePrev();
        updateButtonStates();
      }
      return;
    }

    // Next button
    if (e.target.closest(CONFIG.nextButtonSelector)) {
      e.preventDefault();
      e.stopPropagation();
      const swiper = getSwiper();
      if (swiper && !swiper.isEnd) {
        swiper.slideNext();
        updateButtonStates();
      }
      return;
    }

    // Slide click
    const slide = e.target.closest(CONFIG.slideSelector);
    if (slide) {
      e.preventDefault();
      e.stopPropagation();
      const gifUrl = slide.dataset.mediaUrl;
      if (gifUrl) openGif(gifUrl);
      return;
    }

    // Close button
    if (e.target.closest(CONFIG.closeButtonSelector)) {
      closeGif();
      return;
    }

    // Retry button
    if (e.target.closest('.retry-button')) {
      closeGif();
      return;
    }

    // Overlay click
    if (e.target.matches(CONFIG.overlaySelector)) {
      closeGif();
      return;
    }
  }

  function handleKeydown(e) {
    if (e.key === 'Escape') {
      const overlay = document.querySelector(CONFIG.overlaySelector);
      if (overlay && !overlay.classList.contains('hidden')) {
        closeGif();
      }
    }
  }

  function protectCarousel() {
    const swiperEl = document.querySelector(CONFIG.swiperSelector);
    if (swiperEl && !swiperEl.swiper) {
      initGifCarousel();
    }

    const prevBtn = document.querySelector(CONFIG.prevButtonSelector);
    const nextBtn = document.querySelector(CONFIG.nextButtonSelector);

    if (prevBtn) {
      prevBtn.classList.remove('hidden');
      prevBtn.style.display = 'flex';
      prevBtn.style.visibility = 'visible';
    }

    if (nextBtn) {
      nextBtn.classList.remove('hidden');
      nextBtn.style.display = 'flex';
      nextBtn.style.visibility = 'visible';
    }

    updateButtonStates();
  }

  // Initialize
  function init() {
    document.addEventListener('click', handleClick);
    document.addEventListener('keydown', handleKeydown);
    initGifCarousel();
    setInterval(protectCarousel, CONFIG.protectionInterval);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();